var React = require('react');

function HowTo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.463.142C7.01 4.523 9.946 11.72 9.946 11.72 8.702 11.2 7.396 8.656 7.2 7.152c-.074-.56-.718-.789-1.096-.39C4.915 8.015 3.014 11.024 3 14.403v.071c.007 1.765.532 3.627 1.943 5.391 3.89 4.864 13.434 4.057 15.568-2.345A9.252 9.252 0 0021 14.633v-.108c-.03-4.91-4.118-8.547-5.85-9.738-1.275-.878-1.51-2.674-1.503-3.922.003-.483-.39-.865-.79-.865a.62.62 0 00-.394.142M13.283 14s6.563 8.23-.71 8.916c-.601.056-1.079.084-1.451.084-4.141 0 4.704-3.438 2.16-9","fillRule":"evenodd"}));
}

HowTo.defaultProps = {"width":"24","height":"24"};

module.exports = HowTo;

HowTo.default = HowTo;
